import { Grid, Typography } from "@mui/material";
import React from "react";

import filterIcon from "../../../../styles/svg/epic-icon.svg";
import DrawerGlobalComp from "../../../../components/Drawer";
import { MemoizedMobileFilters } from "./MobileFilters";
import { CustomButton } from "../../../../components/Button/Button";
import newSearchIcon from "../../../../styles/svg/newSearchIcon.svg";
import GlobalSearch from "../../../../components/Search";
import { useWorklogHeaderState } from "../../hooks/useWorklogHeaderState";

function Header() {
  const {
    clearFilters,
    closeFilterDrawer,
    filterDrawer,
    groupingUser,
    handleApplyWorklogFilter,
    handleChange,
    handleOpenSearchField,
    hoursLabel,
    inputValue,
    isMobile,
    openFilterDrawer,
    openSearchField,
    teams,
    trigger,
  } = useWorklogHeaderState();

  return (
    <>
      {isMobile ? (
        <div
          className="pos-sticky mt-4 ml-4 mb-2 mobile-worklog-header-div"
          style={{ top: trigger ? "0px" : "50px" }}>
          {openSearchField ? (
            <Grid
              container
              item
              xs={12}
              className="remove-container-width fixed-ui mobile-search-field"
              justifyContent={"center"}
              alignItems={"center"}>
              <GlobalSearch
                placeholder={"Search..."}
                searchText={inputValue}
                handleChange={handleChange}
                onCancel={handleOpenSearchField}
                showCancel={true}
                fullWidth={true}
              />
            </Grid>
          ) : (
            <div className="d-flex mb-2 mr-3 justify-content-space-between align-items-center ">
              <div className="d-flex align-items-center">
                <Typography className="worklog_head">Worklogs</Typography>

                <span className="hours-header ml-2">{hoursLabel}</span>
              </div>
              <div className="d-flex align-items-center mobile-search-icon-div">
                <img
                  src={newSearchIcon}
                  className="mobile-board-search-icon"
                  alt="search"
                  onClick={handleOpenSearchField}
                />
                <img
                  src={filterIcon}
                  alt="filter"
                  style={{ marginRight: "8px" }}
                  onClick={openFilterDrawer}
                />
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="d-flex justify-content-space-between mb-4">
          <div className="d-flex">
            <p className="worklog_head mr-4">Worklogs</p>
            <span className="hours-header">{hoursLabel}</span>
          </div>
        </div>
      )}
      <DrawerGlobalComp open={filterDrawer} setOpen={closeFilterDrawer}>
          <MemoizedMobileFilters
            clearFilters={clearFilters}
            groupingUser={groupingUser}
            teams={teams}
          />

          <div className="mt-4">
            <CustomButton
              variant="contained"
              color="primary"
              onClick={handleApplyWorklogFilter}
              className="mobile-board-filter-apply-btn">
              Apply
            </CustomButton>
          </div>
      </DrawerGlobalComp>
    </>
  );
}

export default React.memo(Header);
